import { z } from 'zod';
import { PRICE_CATEGORIES, PRICE_PERIODS, PRICE_UNITS } from '../constants/index';

export const PriceCreateSchema = z.object({
  category: z.enum(PRICE_CATEGORIES),
  label: z.string().trim().min(2).max(200),
  amount: z.number().int().min(0).max(10_000_000),
  unit: z.enum(PRICE_UNITS),
  period: z.enum(PRICE_PERIODS).default('all_year'),
  sortOrder: z.number().int().min(0).max(10_000).default(0),
  active: z.boolean().default(true),
  note: z.string().trim().max(500).optional().or(z.literal('')),
});

export type PriceCreateInput = z.infer<typeof PriceCreateSchema>;

export const PriceUpdateSchema = PriceCreateSchema.partial();
export type PriceUpdateInput = z.infer<typeof PriceUpdateSchema>;
